import { DefaultUrlSerializer, UrlTree } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable()
export class CustomUrlSerializer extends DefaultUrlSerializer {
    override parse(url: string): UrlTree {
        if (url.startsWith('/shop/')) {
            const safeUrl = url
                .replace(/\(/g, '%28')
                .replace(/\)/g, '%29');

            return super.parse(safeUrl);
        }

        // Para otras rutas, usa el comportamiento por defecto
        return super.parse(url);
    }
}
